// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-progress {
  pointer-events: none;
  background: var(--purple6);
  position: fixed;
  z-index: 1031;
  top: 0;
  left: 0;
  width: 0;
  height: 4px;
  transition: all ease 0.3s;
}

.product-block:last-child .product-block-header {
  border-bottom: 1px solid var(--black1);
}
.product-block-header {
  background: var(--black0);
  border-top: 1px solid var(--black1);
  border-bottom: none;
  padding: 0.8rem 2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  user-select: none;
}
.product-block-header.active {
  border-bottom: 1px solid var(--black1);
}
.product-block-header-optional {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  text-align: right;
  color: var(--black4);
}
.product-block-header svg {
  margin-right: 1rem;
}
.product-block-header span {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: var(--black9);
}

.product-form {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.product-form .paylixecommerce-checkbox {
  width: 100%;
  margin-right: 0;
  margin-bottom: 1rem;
}
@media (max-width: 768px) {
  .product-form {
    flex-direction: column;
  }
}
.product-form-main-back {
  padding: 2rem;
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .product-block-header {
    padding: 0.5rem 1.25rem;
  }
  .product-form {
    flex-direction: column;
  }
  .product-form-main-back {
    padding: 1rem;
  }
}
.tooltip-inner {
  max-width: 350px;
}

.paylixecommerce-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

@media (max-width: 768px) {
  .wm-100 {
    width: 100% !important;
    margin-right: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/products/product/screens/components/style.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,0BAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;AACF;;AAOI;EACE,sCAAA;AAJN;AAQE;EACE,yBAAA;EACA,mCAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;AANJ;AAQI;EACE,sCAAA;AANN;AASI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;AAPN;AAUI;EACE,kBAAA;AARN;AAWI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AATN;;AAeA;EACE,aAAA;EACA,8BAAA;EACA,sBAAA;AAZF;AAcE;EACI,WAAA;EACA,eAAA;EACA,mBAAA;AAZN;AAeE;EAXF;IAYI,sBAAA;EAZF;AACF;AAcE;EACI,aAAA;EACA,gBAAA;AAZN;;AAiBA;EAGI;IACE,uBAAA;EAhBJ;EAiCA;IACE,sBAAA;EA/BF;EAiCE;IACE,aAAA;EA/BJ;AACF;AAsCA;EACE,gBAAA;AApCF;;AAuCA;EACE,wBAAA;EACA,qBAAA;EACA,gBAAA;AApCF;;AAwCE;EADF;IAEI,sBAAA;IACA,0BAAA;EApCF;AACF","sourcesContent":[".product-progress {\n  pointer-events: none;\n  background: var(--purple6);\n  position: fixed;\n  z-index: 1031;\n  top: 0;\n  left: 0;\n  width: 0;\n  height: 4px;\n  transition: all ease .3s;\n}\n\n\n.product-block {\n\n\n  &:last-child {\n    .product-block-header {\n      border-bottom: 1px solid var(--black1);\n    }\n  }\n\n  &-header {\n    background: var(--black0);\n    border-top: 1px solid var(--black1);\n    border-bottom: none;\n    padding: .8rem 2rem;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    user-select: none;\n\n    &.active {\n      border-bottom: 1px solid var(--black1);\n    }\n\n    &-optional {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 13px;\n      line-height: 16px;\n      text-align: right;\n      color: var(--black4);\n    }\n\n    svg {\n      margin-right: 1rem;\n    }\n\n    span {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 17px;\n      color: var(--black9);\n    }\n  }\n}\n\n\n.product-form {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n\n  .paylixecommerce-checkbox {\n      width: 100%;\n      margin-right: 0;\n      margin-bottom: 1rem;\n  }\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n  }\n\n  &-main-back {\n      padding: 2rem;\n      margin-bottom: 0;\n  }\n};\n\n\n@media (max-width: 768px) {\n\n  .product-block {\n    &-header {\n      padding: .5rem 1.25rem;\n\n      &-optional {\n\n      }\n\n      svg {\n\n      }\n\n      span {\n\n      }\n    }\n  }\n\n\n  .product-form {\n    flex-direction: column;\n\n    &-main-back {\n      padding: 1rem;\n    }\n  };\n\n\n}\n\n\n.tooltip-inner {\n  max-width: 350px;\n};\n\n.paylixecommerce-input {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\n.wm-100 {\n  @media (max-width: 768px) {\n    width: 100% !important;\n    margin-right: 0 !important;\n  }\n};\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
